// extracted by mini-css-extract-plugin
export default {"sidemenu":"SidePanelMenu_sidemenu__sx4Oy","sidemenu-item":"SidePanelMenu_sidemenu-item__etQRT","rotate-180":"SidePanelMenu_rotate-180__nixyZ"};